module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_foodservice-fd290e8c25d78011ee48123da4184fa4.svg";